import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Person from '@mui/icons-material/Person';
import Group from '@mui/icons-material/Group';
import DriveEta from '@mui/icons-material/DriveEta';

import { grey, deepOrange } from '@mui/material/colors';

const styles = {
    statut0: {
        color: grey[500]
    },

    button: {
        position: 'static'
    },

    warningTooltip: {
        background: deepOrange[500]
    }
};

class ReclamationPicto extends React.Component {
    render() {
        const { picto, classes, onClickAffectation, autoriseAffectation, fromDetail } = this.props;

        switch (picto) {

            case 0: {
                if (autoriseAffectation === true)
                    return (
                        <Tooltip title="Affecté">
                            <IconButton
                                disableRipple
                                className={classes.button}
                                onClick={onClickAffectation}
                                size="large">
                                <Person className={fromDetail !== true ? classes.statut0 : null} />
                            </IconButton>
                        </Tooltip>
                    );
                else
                    return (
                        <Tooltip title="Affecté. Vous n'avez pas les droits pour modifier l'affectation." classes={{ tooltip: classes.warningTooltip }}>
                            <IconButton disableRipple className={classes.button} size="large">
                                <Person className={fromDetail !== true ? classes.statut0 : null} />
                            </IconButton>
                        </Tooltip>
                    );
            }




            case 1: {
                if (autoriseAffectation === true)
                    return (
                        <Tooltip title="Groupe">
                            <IconButton
                                disableRipple
                                className={classes.button}
                                onClick={onClickAffectation}
                                size="large">
                                <Group className={fromDetail !== true ? classes.statut0 : null} />
                            </IconButton>
                        </Tooltip>
                    );
                else
                    return (
                        <Tooltip title="Groupe. Vous n'avez pas les droits pour modifier l'affectation." classes={{ tooltip: classes.warningTooltip }}>
                            <IconButton disableRipple className={classes.button} size="large">
                                <Group className={fromDetail !== true ? classes.statut0 : null} />
                            </IconButton>
                        </Tooltip>
                    );
            }


            case 2: {
                if (autoriseAffectation === true)
                    return (
                        <Tooltip title="Pilote">
                            <IconButton
                                disableRipple
                                className={classes.button}
                                onClick={onClickAffectation}
                                size="large">
                                <DriveEta className={fromDetail !== true ? classes.statut0 : null} />
                            </IconButton>
                        </Tooltip>
                    );
                else
                    return (
                        <Tooltip title="Pilote. Vous n'avez pas les droits pour modifier l'affectation." classes={{ tooltip: classes.warningTooltip }}>
                            <IconButton disableRipple className={classes.button} size="large">
                                <DriveEta className={fromDetail !== true ? classes.statut0 : null} />
                            </IconButton>
                        </Tooltip>
                    );
            }


            default: return null;
        }
    }
}

ReclamationPicto.propTypes = {
    picto: PropTypes.number.isRequired,
    classes: PropTypes.object.isRequired,
    onClickAffectation: PropTypes.func.isRequired,
    autoriseAffectation: PropTypes.bool.isRequired,
    fromDetail: PropTypes.bool
};

ReclamationPicto.defaultProps = {
    autoriseAffectation: false
}

export default withStyles(styles)(ReclamationPicto);